<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('paymentToVendor.pageTitle') }}</h1>
      <ts-breadcrumb
        :items="[
          { text: $t('home'), href: '/' },
          {
            text: $t('paymentToVendor.pageTitle'),
            active: true
          }
        ]"
      />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <div class="d-flex justify-content-between">
          <div class="ts-flex ts-items-center ts-space-x-3">
            <ts-button outline color="info" @click.prevent="addNew">
              {{
              $t('add_new')
              }}
            </ts-button>
            <a-range-picker
              v-model="dateRange"
              :allowClear="false"
              format="DD-MM-YYYY"
              valueFormat="DD-MM-YYYY"
              style="width:200px"
              @change="fetchData()"
            />
          </div>
          <div class="d-flex ts-space-x-3 ts-items-center">
            <ts-input
              v-model="search"
							v-tooltip="$t('paymentToVendor.search')"
              :placeholder="$t('search')"
              style="width: 250px;"
              class="inline-block"
            />
            <ts-filter ref="filter">
              <div class="row">
                <div class="col-md-12">
                  <label class="">{{ $t('paymentToVendor.branch') }}</label>
                  <ts-branch-filter
                    @filter="branchFilter" 
                    class="ts-w-full"
                  ></ts-branch-filter>
                </div>
              </div>
            </ts-filter>
          </div>
        </div>
      </ts-card-wrapper>
			<div class="ts-overflow-auto">
				<ts-table 
          :columns="columns" 
          :records="resources" 
          :loading="loading"
          :rowGroup="{
            field: 'payment_date'
          }"
        >
					<template v-slot="{ record }">
						<td>{{ record.branch.branch_name_en }}</td>
						<td>{{ record.supplier.vendor_name }}</td>
						<td>{{ record.bill_number }}</td>
						<td>{{ record.stock_in.stock_in_number }}</td>
						<td class="ts-text-right ts-text-blue-700 ts-font-semibold" >{{ $currencyFormat(record.bill_amount) }}</td>
						<!-- <td class="text-center">{{ record.discount_type }}</td>
						<td class="text-right">{{ record.discount_rate }}</td>
						<td class="text-right">{{ record.discount_amount }}</td> -->
						<td class="text-right">{{ $currencyFormat(record.amount_paid) }}</td>
						<td class="text-right ts-text-red-600 ts-font-semibold">{{ $currencyFormat(record.amount_due) }}</td>
						<td>{{ record.payment_method.payment_method }}</td>
						<td>{{ record.next_payment_date }}</td>
						<!-- <td>{{ record.user.name }}</td>
						<td class="ts-whitespace-no-wrap">{{ record.created_date }}</td> -->
						<td class="text-center ts-space-x-3 ts-whitespace-no-wrap">
              <a
                href="#"
                v-tooltip="$t('paymentToVendor.reprint')"
                class="text-primary text-red"
                @click.prevent="reprintReport(record)"
              >
                <i class="fas fa-file-pdf"></i>
              </a>
							<a
								href="#"
								v-tooltip="$t('edit')"
								class="text-primary"
								@click.prevent="edit(record)"
							>
								<i class="fas fa-edit"></i>
							</a>
							<a-popconfirm
								placement="leftTop"
								:title="$t('are_you_sure_to_delete')"
								:ok-text="$t('yes')"
								:cancel-text="$t('no')"
								@confirm="deleteRecord(record)"
							>
								<a href="#" :disabled="record._deleting">
									<i class="fas fa-circle-notch spin" v-if="record._deleting"></i>
									<i class="fa fa-trash text-red" v-else></i>
								</a>
							</a-popconfirm>
						</td>
					</template>
				</ts-table>
			</div>
      <div class="d-flex justify-content-end p-15">
        <ts-pagination
          v-model="pagination"
          @navigate="fetchData"
        ></ts-pagination>
      </div>
      <!-- form-action -->
      <a-modal
        v-if="showForm"
        v-model="showForm"
        :title="$t('paymentToVendor.pageTitle')"
        centered
        width="30%"
        @cancel="clearEdit"
        :maskClosable="false"
        :zIndex="1020"
        :footer="null"
      >
        <from-action
          @cancel="clearEdit"
          @fetchData="fetchData"
        />
      </a-modal>
      <a-modal :title="$t('pdf')" width="50%" v-model="show_pdf" :footer="null">
        <ts-preview-pdf v-model="waiting" :src="src" />
      </a-modal>
    </ts-card>
  </div>
</template>

<script>
import { debounce } from 'lodash'
import { mapState } from 'vuex'
import FromAction from './form'
import { Errors } from 'form-backend-validation'
import Reason from './reason_delete'

export default {
  name: 'payToVendorIndex',
  components: {
    FromAction,
		Reason
  },
  data() {
    return {
      loading: false,
      showForm: false,
      waiting: false,
      show_pdf: false,
      src: '',
			errors: new Errors(),
			model: {
        deleted_reason: null
      }
    }
  },
  created() {
    this.fetchData()
  },
  computed: {
    ...mapState('supplier/payment', ['resources', 'pagination']),
    search: {
      get() {
        return this.$store.state.supplier.payment.search
      },
      set(newValue) {
        this.$store.commit('supplier/payment/SET_SEARCH', newValue)
        this.$store.commit('supplier/payment/RESET_CURRENT_PAGE')
      }
    },
		dateRange: {
      get() {
        return this.$store.state.supplier.payment.dateRange
      },
      set(newValue) {
        this.$store.commit('supplier/payment/SET_DATE_RANGE', newValue)
      }
    },
    columns() {
      return [
        { name: this.$t('paymentToVendor.branchName') },
        { name: this.$t('paymentToVendor.vendor') },
        { name: this.$t('paymentToVendor.billNumber') },
        { name: this.$t('paymentToVendor.stockInNumber') },
        { name: this.$t('paymentToVendor.billAmount'), style:'text-align:right' },
        // { name: this.$t('paymentToVendor.discountType') },
        // { name: this.$t('paymentToVendor.discountRate'), style:'text-align:right' },
        // { name: this.$t('paymentToVendor.discountAmount'), style:'text-align:right' },
        { name: this.$t('paymentToVendor.amountPaid'), style:'text-align:right' },
        { name: this.$t('paymentToVendor.amountDue'), style:'text-align:right' },
        { name: this.$t('paymentToVendor.paymentMethod') },
        { name: this.$t('paymentToVendor.nextPaymentDate') },
        // { name: this.$t('paymentToVendor.createBy') },
        // { name: this.$t('paymentToVendor.createdDate') },
        { name: this.$t('actions'), style: 'text-align:center; width: 1px;' }
      ]
    }
  },
  methods: {
    fetchData(attributes) {
      this.loading = true
      this.$store
        .dispatch('supplier/payment/fetch', { ...attributes })
        .then(response => {
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          this.$toasted.error(error.message)
        })
    },
    addNew() {
      this.showForm = true
    },
    edit(record) {
      this.$store.commit('supplier/payment/SET_EDIT_DATA', record)
      this.showForm = true
    },
    clearEdit(){
      this.$store.commit('supplier/payment/SET_EDIT_DATA', {})
      this.showForm = false
      this.fetchData()
		},
		deleteRecord(record) {
      this.model.deleted_reason = null
      this.$confirm({
        title: this.$t('are_you_sure_to_delete'),
        content: h =>
          h(Reason, {
            props: {
              value: this.model,
              validate: this.errors,
              placeholder: this.$t('paymentToVendor.leaveReason')
            }
          }),
        okText: this.$t('yes'),
        okType: 'danger',
        cancelText: this.$t('no'),
        onOk: () => {
          return this.$store.dispatch('supplier/payment/destroy', {
            id: record.pay_tran_id,
            data: this.model
          })
            .then(response => {
              this.$toasted.success(response.message)
              this.fetchData()
              return Promise.resolve(response)
            })
            .catch(error => {
              this.$toasted.error(error.message)
              this.errors = new Errors(error.errors)
              return Promise.reject(error)
            })
        },
        onCancel() {}
      })
    },
    branchFilter(value){
      this.$store.commit('supplier/payment/SET_BRANCH_ID', value)
      this.fetchData()
    },
    reprintReport(record) {
      this.show_pdf = true
      this.waiting = true
      this.src = ''
      this.$store
        .dispatch('supplier/payment/toPdf', record.pay_tran_id)
        .then((response) => {
          this.src = response.url
        })
        .catch((error) => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.waiting = false
        })
    },
  },
  watch: {
    search: debounce(function(search) {
      this.fetchData()
    }, 500)
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit('supplier/payment/RESET_STATE')
    next()
  }
}
</script>
